import {
  SERVICE_OFF,
  SERVICE_ON,
  SERVICE_ON_FF,
  SERVICE_SEND,
} from '../constants'

const service = {
  make: false,
  send: false,
}

export const serviceReducer = (state = service, action) => {
  const { type, payload } = action
  switch (type) {
    case SERVICE_ON:
      return {
        ...service,
        make: payload,
      }
    case SERVICE_OFF:
      return {
        ...service,
        make: false,
      }
    case SERVICE_SEND:
      return {
        ...state,
        make: false,
        send: true,
      }

    default:
      return state
  }
}
